
import Vue from 'vue'
import Component from 'vue-class-component'
import {
  LoginWithOtp,
  sendLoginOtp
} from '@/components/admin/users/users.service'
import { LoginVM } from '@/models'

@Component
export default class OtpLoginPage extends Vue {
  username = ''
  otp = ''

  loading = false
  error: string | null = null
  success: string | null = null

  hint: string | null =
    'If you were just unlocked, you must login with OTP and then change your password. Check junk/spam for the MAG DASHBOARD OTP email.'

  // resend cooldown
  resendSecondsLeft = 0
  resendTimer: number | null = null

  mounted() {
    // Optional: prefill username from query string (?username=AA.029891)
    const u = (this.$route.query.username as string) || ''
    if (u) this.username = u
  }

  beforeDestroy() {
    if (this.resendTimer) window.clearInterval(this.resendTimer)
  }

  get canSubmit(): boolean {
    return this.username.length > 0 && this.otp.length === 6
  }

  get resendDisabled(): boolean {
    return this.resendSecondsLeft > 0 || !this.username
  }

  clearOtp() {
    this.otp = ''
  }

  startResendCooldown() {
    this.resendSecondsLeft = 60
    if (this.resendTimer) window.clearInterval(this.resendTimer)
    this.resendTimer = window.setInterval(() => {
      this.resendSecondsLeft -= 1
      if (this.resendSecondsLeft <= 0 && this.resendTimer) {
        window.clearInterval(this.resendTimer)
        this.resendTimer = null
      }
    }, 1000)
  }

  async resendOtp() {
    if (this.resendDisabled) return
    this.error = null
    this.success = null
    try {
      this.loading = true
      await sendLoginOtp(this.username)
      this.success =
        'If this account needs a password change, a new code was sent. Check inbox and junk/spam.'
      this.startResendCooldown()
    } catch (e) {
      this.error = 'Could not resend the code. Try again in a moment.'
    } finally {
      this.loading = false
    }
  }

  async submit() {
    this.error = null
    this.success = null

    if (!this.canSubmit) return

    try {
      this.loading = true
      const LoginVm: LoginVM = {
        userName: this.username,
        otp: this.otp,
        code: '', // Not needed for OTP login, but API expects it
        password: 'XXxxX', // Not needed for OTP login, but API expects it
        trustBrowser: false
      }
      console.log(LoginVm)
      // OTP login endpoint: returns a session with token + RequirePasswordChange=true
      const { data } = await LoginWithOtp(LoginVm)

      console.log(data)
      // Save token (adjust to your storage approach)
      if (data && data.token) {
        localStorage.setItem('token', data.token)
      }

      // If backend marks password change required, go to change-password
      if (data && data.requirePasswordChange === true) {
        this.$router.push({ name: 'ChangePassword' })
        return
      }

      // Otherwise go home
      this.$router.push({ path: '/' })
    } catch (e) {
      const payload = e?.response?.data
      this.error =
        payload?.errors?.[0] ||
        payload?.Errors ||
        payload?.error ||
        'Invalid or expired OTP.'
    } finally {
      this.loading = false
    }
  }
}
